import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Event, PaginatedResponse, Params } from "../../types/Types";

export type FindEventsParams = Params & {
  /** Server-side: filter online (true) or onsite (false). */
  isOnline?: boolean;
  /** Server-side: `upcoming` | `past` (UK calendar day vs today). */
  timing?: "upcoming" | "past";
};

export function useFindEvents({
  enabled = true,
  pageSize = 10,
  page = 1,
  searchTerm,
  isOnline,
  timing,
}: FindEventsParams = {}) {
  return useQuery({
    enabled,
    queryKey: ["events", { pageSize, page, searchTerm, isOnline, timing }],
    queryFn: async () => {
      const params = new URLSearchParams({
        pageNumber: String(page),
        pageSize: String(pageSize),
      });

      const trimmedSearch = searchTerm?.trim();
      if (trimmedSearch) {
        params.set("searchTerm", trimmedSearch);
      }
      if (typeof isOnline === "boolean") {
        params.set("isOnline", String(isOnline));
      }
      if (timing === "upcoming" || timing === "past") {
        params.set("timing", timing);
      }

      const url = getAPIURL(`/Event/All?${params.toString()}`);
      return axiosInstance
        .get<PaginatedResponse<Event>>(url)
        .then((res) => res.data);
    },
  });
}
